import { api } from './api';
import { Link, navigate, usePath } from './router';
import { AccrualsPage, DashboardPage, LoginPage, PurchasesPage, RulesPage, ShopPage } from './pages';

const ROUTES: Record<string, () => JSX.Element> = {
  '/': DashboardPage,
  '/referrals': AccrualsPage,
  '/shop': ShopPage,
  '/purchases': PurchasesPage,
  '/rules': RulesPage,
};

export function App() {
  const path = usePath();

  // Страница входа без общей обвязки: на ней ещё нет ни сессии, ни данных.
  if (path === '/login') return <LoginPage />;

  const Page = ROUTES[path] ?? NotFound;

  return (
    <>
      <header className="topbar">
        <div className="topbar-inner">
          <Link to="/" className="brand">
            Бонусы
          </Link>
          <nav className="tabs">
            <Link to="/">Главная</Link>
            <Link to="/referrals">Приглашённые</Link>
            <Link to="/shop">Лавка</Link>
            <Link to="/purchases">Покупки</Link>
            <Link to="/rules">Правила</Link>
            <a
              href="/login"
              onClick={async (e) => {
                e.preventDefault();
                await api.logout().catch(() => undefined);
                navigate('/login');
              }}
            >
              Выйти
            </a>
          </nav>
        </div>
      </header>
      <main className="layout">
        <Page />
      </main>
    </>
  );
}

function NotFound() {
  return (
    <div className="center">
      <div>
        <h1>Страница не найдена</h1>
        <Link to="/">На главную</Link>
      </div>
    </div>
  );
}
